export const environment = {
  production: true,
  buildId: '4034284008324471',
  configFile: 'config.json',
};
